import { createElement } from "react";
import { Routes, Route } from "react-router-dom";
import { useGetContext } from "@onefront/forrestjs-react-root";
import { ErrorBoundary } from "../../utils/ErrorBoundary";

export const LayoutRoutes = ({ items = [] }) => {
  const PageNotFound = useGetContext("one.layout.404.component");

  if (!items.length) {
    return (
      <div
        style={{
          margin: "10px 23px"
        }}
      >
        No routes configured.
        <br />
        Please hook into{" "}
        <em>
          <code>LAYOUT_ROUTE</code>
        </em>
        .
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <Routes>
        {items.map((item, idx) => {
          const { component, element, props = {}, ...routeConfig } = item;
          const useElement = element || createElement(component, props);
          return <Route key={idx} element={useElement} {...routeConfig} />;
        })}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </ErrorBoundary>
  );
};
